import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MainNavbar.css';
import Profile from '../../assets/profile.jpg';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { useLanguage } from '../../hooks/useLanguage';

const MainNavbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { getText } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  // Función para determinar si una ruta está activa
  const isActive = (path) => {
    if (path === '/portfolio') {
      return location.pathname === '/portfolio' || 
             location.pathname === '/' ||
             location.pathname === '/about' ||
             location.pathname === '/contact';
    }
    return location.pathname === path;
  };

  return (
    <nav className="main-navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <div className="profile-section">
            <div className="profile-avatar">
              <img src={Profile} alt="Anthony Marín" />
            </div>
            <div className="profile-info">
              <h2>Anthony Marín</h2>
              <span className="brand-subtitle">Full Stack Developer</span>
            </div>
          </div>
        </div>

        {/* Menú Desktop */}
        <div className="navbar-menu desktop-menu">
          <button 
            className={`nav-link ${isActive('/portfolio') ? 'active' : ''}`}
            onClick={() => handleNavigation('/portfolio')}
          >
            {getText('navigation.portfolio')}
          </button>
          <button 
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            onClick={() => handleNavigation('/about')}
          >
            {getText('navigation.about')}
          </button>
          <button 
            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={() => handleNavigation('/contact')}
          >
            {getText('navigation.contact')}
          </button>
          <button 
            className={`nav-link ${isActive('/english') ? 'active' : ''}`}
            onClick={() => handleNavigation('/english')}
          >
            {getText('navigation.english')}
          </button>
          <button 
            className={`nav-link ${isActive('/stories') ? 'active' : ''}`}
            onClick={() => handleNavigation('/stories')}
          >
            {getText('navigation.stories')}
          </button>
          {/* Selector de idioma */}
          <LanguageSelector />
        </div>

        {/* Botón menú móvil */}
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>

      {/* Menú Móvil */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <button 
          className={`mobile-nav-link ${isActive('/portfolio') ? 'active' : ''}`}
          onClick={() => handleNavigation('/portfolio')}
        >
          💼 {getText('navigation.portfolio')}
        </button>
        <button 
          className={`mobile-nav-link ${isActive('/about') ? 'active' : ''}`}
          onClick={() => handleNavigation('/about')}
        >
          👨‍💻 {getText('navigation.about')}
        </button>
        <button 
          className={`mobile-nav-link ${isActive('/contact') ? 'active' : ''}`}
          onClick={() => handleNavigation('/contact')}
        >
          📞 {getText('navigation.contact')}
        </button>
        <button 
          className={`mobile-nav-link ${isActive('/english') ? 'active' : ''}`}
          onClick={() => handleNavigation('/english')}
        >
          📚 {getText('navigation.english')}
        </button>
        <button 
          className={`mobile-nav-link ${isActive('/stories') ? 'active' : ''}`}
          onClick={() => handleNavigation('/stories')}
        >
          📖 {getText('navigation.stories')}
        </button>
        {/* Selector de idioma en móvil */}
        <div className="mobile-language-selector">
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
};

export default MainNavbar;
